export enum FeatureFlag {
  INTERCOM_CONNEXION_UPGRADE = 'intercom_connexion_upgrade',
  DASHBOARD_PDF_EXPORT = 'dashboard_pdf_export',
  ACTIONS_GANTT_FILTERS = 'WAL_1292_actions_gantt_filters',
  EVALUATION_REVIEW = 'WAL_1346_evaluation_review',
  CAMPAIGN_MANAGER = 'WAL-1513-campaign_manager',
  INSERT_ACTION_V2 = 'insert_action_endpoint',
  EXPORT_IMPORT_PERIMETERS_V2 = 'export_import_perimeters_v2',
  TO_REVIEW_ACTION_STATUS = 'WAL_1205_to_review_action_status',
}

export interface CustomerFeatureFlag {
  enable: boolean
  feature_flag: {
    id: number
    name: string
  }
  feature_flag_id: number
  id: number
}
